import world from "./world";

const localeShort = TheApp.Env.LocaleShort;
const sortedCountries = world?.sort((a, b) => a?.[localeShort]?.localeCompare(b?.[localeShort], localeShort));

export default sortedCountries;